import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { string, func } from 'prop-types';
import { QueryContext } from '../../../containers/Search/context';
import styles from './style.module.scss';
import { getJobSlug } from '../../../utils/common';

const Title = ({ id, title, onClick }) => {
  const { query: highlight = '' } = useContext(QueryContext);

  // Wrap the first occurrence of search term in a class so we can highlight it.
  let highlightedTitle = title;
  const start = title.toLowerCase().indexOf(highlight.toLowerCase());
  if (highlight && start >= 0) {
    const end = start + highlight.length;
    const parts = [
      title.substr(0, start),
      `<span class="${styles.highlighted}">`,
      title.substr(start, highlight.length),
      '</span>',
      title.substr(end, title.length - 1),
    ];
    highlightedTitle = parts.join('');
  }

  return (
    <Link
      className="tds-link"
      to={`job/${getJobSlug(id, title)}`}
      dangerouslySetInnerHTML={{ __html: highlightedTitle }}
      onClick={onClick}
    />
  );
};

Title.propTypes = {
  id: string.isRequired,
  title: string.isRequired, // data object for this job application
  onClick: func.isRequired,
};

export default Title;
